<template lang="html">
  <div class="">
    <br>
    <Form ref="form" v-if="form" :label-width="160" @submit.native="post(form)" :model="form" :show-message="false">
      <Row>
        <Col offset="6" span="24"><h2>Contatto</h2><br><br></Col>
        <Col span="12"><FormItem label="Nome o Ragione Sociale" :rules="req" prop="first_name">
          <Input v-model="form.first_name"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Cognome" prop="last_name">
          <Input v-model="form.last_name"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Partita IVA">
          <Input v-model="form.piva"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Codice Fiscale">
          <Input v-model="form.cf"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Email">
          <Input v-model="form.email" type="email"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Telefono">
          <Input v-model="form.telephone"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Indirizzo">
          <Input v-model="form.addr_street"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="Città">
          <Input v-model="form.addr_city"/>
        </FormItem></Col>
        <Col span="12"><FormItem label="CAP">
          <Input v-model="form.addr_zip"/>
        </FormItem></Col>
        <Col span="24" style="text-align:center">
          <FormItem class="">
            <Button type="error" @click="$emit('close')">
              Annulla
            </Button>
            &nbsp;
            <Button type="primary" @click="post(form)">
              Salva
            </Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  props: [
    'edit',
  ],

  data () {
    return {
      form: this.edit ? this._.clone(this.edit) : {},
    }
  },

  computed: {
  },

  mounted() {
  },

  methods: {
  post(data) {
    this.$refs.form.validate((valid) => {
      if (valid) {
        data.company_id = this.$store.company.id
        var is_new = !data.id
        this.$http.post('contacts', data).then(res => {
          this.$emit('close')
          this.$root.$emit('contacts')
        })
      } else {
        this.$Message.error('Controllare gli errori');
      }
    })
  },
  }


}
</script>

<style lang="css">
</style>
